import { NavLink, useNavigate } from 'react-router-dom';
import { CheckCircle2, LogOut, MessageSquare, MessagesSquare, Paperclip, Settings } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { cn } from '@/utils/cn';

const NAV_ITEMS = [
  { to: '/messages', label: 'Messages', icon: MessageSquare },
  { to: '/threads', label: 'Threads', icon: MessagesSquare },
  { to: '/acknowledgements', label: 'Acknowledgements', icon: CheckCircle2 },
  { to: '/medbin', label: 'MEDBIN', icon: Paperclip },
  { to: '/settings', label: 'Settings', icon: Settings },
] as const;

export function Sidebar() {
  const { signOut, user } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
    } finally {
      navigate('/sign-in', { replace: true });
    }
  };

  return (
    <aside className="flex h-screen w-64 flex-col border-r border-gray-200 bg-gray-900 dark:border-gray-700">
      <div className="border-b border-gray-800 px-4 py-5">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-400">Clinio</p>
        <h1 className="text-lg font-semibold text-white">Communicate</h1>
        <p className="mt-1 text-xs text-gray-500">MedCom access</p>
      </div>

      <nav className="flex-1 space-y-1 px-2 py-4">
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-gray-800 text-white'
                  : 'text-gray-300 hover:bg-gray-800 hover:text-white',
              )
            }
          >
            <Icon className="h-4 w-4 shrink-0" />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-gray-800 px-3 py-4">
        {user?.email && (
          <p className="mb-3 truncate px-1 text-xs text-gray-400" title={user.email}>
            {user.email}
          </p>
        )}
        <button
          type="button"
          onClick={() => void handleSignOut()}
          className="flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-gray-300 transition-colors hover:bg-gray-800 hover:text-white"
        >
          <LogOut className="h-4 w-4 shrink-0" />
          Sign out
        </button>
      </div>
    </aside>
  );
}
